export default __webpack_public_path__ + "static/media/330_store01-es-mobile.b8bac524.png";